import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import DetailScreen from '../components/DetailScreen';
import useTruflowData from '../hooks/useTruflowData';
import {
  TaxReserveCard,
  SavingsCard,
  QuarterProgressCard,
  quarterProgressAvailable,
  AnnualBreakdownCard,
  SectionEyebrow,
  Spinner,
} from './Dashboard';

// Taxes detail screen — reserve card, quarterly progress, and the annual
// breakdown, each in its own card under a section eyebrow (same structure as
// Home). Each eyebrow is gated on the same condition as the card beneath it, so
// none can be orphaned. savingsData comes from the shared hook's existing batch,
// so the reserve card's verdict chip costs no extra request.
export default function TaxesScreen() {
  const navigate = useNavigate();
  const savingsCardRef = useRef(null);
  const {
    loading,
    taxData,
    curveData,
    savingsData,
    expensesData,
    paidQuartersData,
    refetchTaxAndPayments,
    savingsModalPool,
    setSavingsModalPool,
    refetchSavingsAndInsights,
  } = useTruflowData();

  const quarterInfo = quarterProgressAvailable(taxData, paidQuartersData);

  return (
    <DetailScreen title="Taxes">
      {loading ? (
        <Spinner />
      ) : (
        <>
          <SectionEyebrow>This quarter</SectionEyebrow>
          <TaxReserveCard
            taxData={taxData}
            savingsData={savingsData}
            navigate={navigate}
          />
          {quarterInfo && (
            <>
              <SectionEyebrow>{quarterInfo.tax_year} progress</SectionEyebrow>
              <QuarterProgressCard
                taxData={taxData}
                paidQuartersData={paidQuartersData}
                onPaidQuartersChanged={refetchTaxAndPayments}
              />
            </>
          )}
          {taxData && (
            <>
              <SectionEyebrow>Annual breakdown</SectionEyebrow>
              <AnnualBreakdownCard taxData={taxData} navigate={navigate} />
            </>
          )}
          {/* Set-aside pools sit with the reserve they fund. SavingsCard owns its
              own modal state and renders its own "Set aside" eyebrow, so it moves
              across intact and cannot leave an orphan heading. */}
          <SavingsCard
            savingsData={savingsData}
            taxData={taxData}
            curveData={curveData}
            expensesData={expensesData}
            containerRef={savingsCardRef}
            modalPool={savingsModalPool}
            onOpenModal={(pool) => setSavingsModalPool(pool)}
            onCloseModal={() => setSavingsModalPool(null)}
            onChanged={refetchSavingsAndInsights}
            navigate={navigate}
          />
        </>
      )}
    </DetailScreen>
  );
}
